import React from 'react';
import { Backdrop, CircularProgress } from '@mui/material';
import { useAuth } from '../context/AuthContext';

/**
 * Displays a full-screen loading backdrop whenever AuthContext.loading is true.
 */
const GlobalLoader = () => {
  const { loading } = useAuth();
  return (
    <Backdrop
      open={loading}
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}
      data-testid="global-loader"
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default GlobalLoader;
